module.exports = __webpack_public_path__ + "8f0d74e70636006c7697cf182d72c6eb.png";